import capitalizeFirstLetter from "./capitalizeFirstLetter";

const getPostalAbbreviation = (langcode) => {
  return capitalizeFirstLetter(langcode.split('-')[1]);
}

export default getPostalAbbreviation;
